import type { Role } from '@ste/shared';
import { useAuth } from './auth.ts';
import { roleOnSite, useConnection, useCurrentSite } from './connection.ts';
import { elevatedRole, useElevation } from './serviceAccess.ts';

/** role of the logged-in user on the selected site (raised while the service access is open) */
export function useRole(): Role | undefined {
  return elevatedRole(useBaseRole(), useElevation(), useSiteKey());
}

/** role without the service access: membership (cloud) or account role (gateway) */
export function useBaseRole(): Role | undefined {
  const mode = useConnection((s) => s.mode);
  const site = useCurrentSite();
  const accountRole = useAuth((s) => s.user?.role);
  return roleOnSite(mode, site, accountRole);
}

function useSiteKey(): string {
  return useConnection((s) => (s.mode === 'cloud' ? (s.siteId ?? '') : 'local'));
}
